import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { capitalizeFirstLetter, useIsMobile } from "../../../../utils";
import {
  activeStylesContinue,
  disabledStylesContinue,
} from "../../../../configs";
import { hoverStylesContinue } from "../../../../configs/stylesLoader";

interface LingerieContinueButtonProps {
  disabled: boolean;
  onClick: () => void;
}

const LingerieContinueButton = forwardRef<
  HTMLButtonElement,
  LingerieContinueButtonProps
>(({ disabled, onClick }, ref) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation("components/intro");
  const [hovered, setHovered] = useState(false);

  const baseStyles: React.CSSProperties = {
    ...(disabled ? disabledStylesContinue : activeStylesContinue),
    ...(hovered && !disabled ? hoverStylesContinue : {}),
    marginTop: isMobile ? "60px" : "30px",
    marginBottom: isMobile ? "20px" : "0",
    textTransform:
      activeStylesContinue.textTransform === "capitalize"
        ? "none"
        : (activeStylesContinue.textTransform as React.CSSProperties["textTransform"]),
    maxHeight: "fit-content",
    position: "relative",
    bottom: 0,
    height: "auto",
    padding: "16px",
  };

  const label =
    activeStylesContinue.textTransform === "capitalize"
      ? capitalizeFirstLetter(t("continue"))
      : t("continue");

  return (
    <button
      tabIndex={0}
      ref={ref}
      type="button"
      disabled={disabled}
      className="continue-button breasts-continue"
      onMouseEnter={(e) => {
        if (isMobile) return;
        setHovered(true);
        if (!disabled) {
          Object.assign(e.currentTarget.style, hoverStylesContinue);
        }
      }}
      onMouseLeave={(e) => {
        setHovered(false);
        if (!disabled) {
          Object.assign(e.currentTarget.style, baseStyles);
        }
      }}
      onClick={onClick}
      style={baseStyles}
    >
      <div style={{ display: "inline-flex", alignItems: "center", gap: 0 }}>
        {label}
      </div>
    </button>
  );
});

LingerieContinueButton.displayName = "LingerieContinueButton";

export default LingerieContinueButton;
